module.exports = __webpack_public_path__ + "img/7.abc0382b.jpg";